import { Style } from 'exceljs';

/*
    This file is used to allow for consistant exports of the Data Source file
    data in the excel format
*/
export const HeaderStyle: Partial<Style> = {
    fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF00008B' }
    },
    font: {
        name: 'Tahoma',
        bold: true,
        color: { argb: 'FFFFFFFF' },
        size: 11,
    }
};

export const RowStyle: Partial<Style> = {
    font: {
        name: 'Tahoma',
        bold: false,
        color: { argb: 'FF000000' },
        size: 11,
    }
};